import React from 'react'
import CommonSectionTitle from '../../../App/Components/CommonSectionTitle'
import { iConsoleError, iConsoleGroup, iConsoleInfo, iConsoleLog, iConsoleTable, iConsoleTime, iConsoleWarn } from '../../../utilities/ImageImports'
import RightContentMap from '../../components/RightContentMap'

const ConsoleMethods = () => {
    return (
        <div className='md:flex text-gray-800 dark:text-cDarkText'>
            <div className='px-1 pb-10'>
                <RightContentMap />
            </div>

            <div className='md:w-[70%] bg-gray-100 dark:bg-cDarkBG2 rounded-lg shadow-lg p-5'>
                <CommonSectionTitle
                    title='JS: Console Methods and Usage'
                    withBackLink={true}
                    backLinkUrl='/play'
                />

                <div className='my-5'>
                    <h2 className="text-lg font-bold mb-4">Console Methods in JavaScript</h2>
                    <ul className="list-disc pl-4">
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.log()</code> method: Used to log messages to the console.
                            <img src={iConsoleLog} alt="" className='my-5 rounded-lg' />
                        </li>
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.info()</code> method: Used to log information to the console.
                            <img src={iConsoleInfo} alt="" className='my-5 rounded-lg' />
                        </li>
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.error()</code> method: Used to log error messages to the console.
                            <img src={iConsoleError} alt="" className='my-5 rounded-lg' />
                        </li>
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.warn()</code> method: Used to log warning messages to the console.
                            <img src={iConsoleWarn} alt="" className='my-5 rounded-lg' />
                        </li>
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.table()</code> method: Used to display data in a tabular format in the console.
                            <img src={iConsoleTable} alt="" className='my-5 rounded-lg' />
                        </li>
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.group() & console.groupEnd()</code> method: Used to display data in a group format in the console with multiple console logs or messages.
                            <img src={iConsoleGroup} alt="" className='my-5 rounded-lg' />
                        </li>
                        <li className="mb-2">
                            <code className="bg-gray-200 dark:bg-cDarkMainBG p-1 rounded-md">console.time() & console.timeEnd()</code> method: Used to display how much time it took to execute some code with results (in milliseconds).
                            <img src={iConsoleTime} alt="" className='my-5 rounded-lg' />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ConsoleMethods